var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-menu',{attrs:{"id":"side","content-id":"page-content"}},[_c('ion-header',[_c('ion-toolbar',[_c('ion-title',{staticClass:"menu-title",attrs:{"color":"medium"}},[_vm._v(" BizPLAT Admin ("+_vm._s(_vm.version)+") ")])],1)],1),_c('ion-content',[_c('db-menu-nav',{attrs:{"params":{ menuList: _vm.menuList, redirects: _vm.redirects }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }